module.exports = __webpack_public_path__ + "img/content.d5f2a220.png";